const defaultFindOptions = { paginationSize: 20, disableSoftDelete: false, query: {} };
export async function findAndLoadAll(app, serviceName, onDataReceived, options = {}) {
    const { paginationSize, disableSoftDelete, query: additionalQuery } = { ...defaultFindOptions, ...options };
    let skip = 0;
    let loadedItemsChunk = null;
    let loadedItemsCount = 0;
    while (loadedItemsChunk === null || loadedItemsChunk.total > loadedItemsCount) {
        const query = { $limit: paginationSize, $skip: skip, ...additionalQuery };
        if (disableSoftDelete) {
            query.$disableSoftDelete = true;
        }
        const result = (await app.service(serviceName).find({
            query,
        }));
        if (Array.isArray(result)) {
            loadedItemsChunk = { data: result, total: 0, limit: paginationSize, skip: 0 };
        }
        else {
            loadedItemsChunk = result;
        }
        onDataReceived(loadedItemsChunk.data);
        if (typeof loadedItemsChunk.skip === 'string') {
            skip = loadedItemsChunk.skip;
        }
        else {
            skip += paginationSize;
        }
        loadedItemsCount += loadedItemsChunk.data.length;
    }
}
//# sourceMappingURL=FeathersUtils.js.map